function hasErrors(errorsObject) {
    return Object.values(errorsObject).some((value) => value !== null);
}

export { hasErrors };
